export default "__VITE_ASSET__OXNiIx6C__"